"use strict";

var _classCallCheck = require("/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/node_modules/@babel/runtime/helpers/inherits");

var _taggedTemplateLiteral = require("/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 1.5em;\n  right: 1.5em;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  padding: 30px 30px;\n  cursor: pointer;\n  ", ";\n  color: ", ";\n  &:hover {\n    text-decoration: underline;\n  }\n  &:hover ", " {\n    display: none;\n  }\n  &:hover ", " {\n    display: flex;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  margin-right: 10px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  top: 80px;\n  @keyframes slideInFromRight {\n    0% {\n      transform: translateX(100%);\n    }\n    100% {\n      transform: translateX(0);\n    }\n  }\n  display: flex;\n  flex-direction: column;\n  background: ", ";\n  width: 100%;\n  height: calc(100% - 80px);\n  animation: 300ms ease-out 0s 1 slideInFromRight;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  @keyframes fadeIn {\n    0% {\n      background: ", ";\n    }\n    100% {\n      background: ", ";\n    }\n  }\n  background: ", ";\n  width: 100%;\n  color: ", ";\n  height: 100vh;\n  z-index: 99999;\n  animation: 300ms ease-out 0s 1 fadeIn;\n  position: fixed;\n  top: 0px;\n  left: 0px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var buttons_1 = require("../buttons");

var Cross_1 = require("../icons/Cross");

var layout_1 = require("../layout");

var react_scrolllock_1 = __importDefault(require("react-scrolllock"));

var MenuMainWrapper = styled_components_1.default.div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.mobileMenuBackground;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.headerBackground;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.mobileMenuBackground;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.copy;
});
var MenuContainer = styled_components_1.default.div(_templateObject2(), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.headerBackground;
});
var MenuItems = styled_components_1.default(layout_1.VerticalLayout)(_templateObject3());
var Icon = styled_components_1.default.span(_templateObject4());
var IconHover = styled_components_1.default(Icon)(_templateObject5());
var MenuItem = styled_components_1.default.div(_templateObject6(), function (_ref6) {
  var theme = _ref6.theme;
  return theme.fonts.h2Style2;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.white;
}, Icon, IconHover);
var CircleButtonContainer = styled_components_1.default.div(_templateObject7());

var ExpandingMenu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ExpandingMenu, _React$Component);

  function ExpandingMenu(props) {
    var _this;

    _classCallCheck(this, ExpandingMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExpandingMenu).call(this, props));
    _this.state = {
      showMenu: _this.props.showMenu
    };
    return _this;
  }

  _createClass(ExpandingMenu, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return this.props.showMenu && React.createElement(MenuMainWrapper, {
        onClick: function onClick() {
          return _this2.props.menuCollapse();
        }
      }, React.createElement(react_scrolllock_1.default, null), React.createElement(CircleButtonContainer, null, React.createElement(buttons_1.CircleButton, {
        id: "mobile_header_left",
        onClick: this.props.menuCollapse,
        dark: true
      }, React.createElement(Cross_1.Cross, {
        onClick: function onClick() {
          return _this2.props.menuCollapse();
        }
      }))), React.createElement(MenuContainer, {
        onClick: function onClick(e) {
          return e.stopPropagation();
        }
      }, React.createElement(MenuItems, null, this.props.menuItems.map(function (item, index) {
        return !item.secondary && React.createElement(MenuItem, {
          key: index,
          onClick: item.onClick
        }, React.createElement(Icon, null, item.icon), React.createElement(IconHover, null, item.iconHover || item.icon), item.label);
      }))));
    }
  }]);

  return ExpandingMenu;
}(React.Component);

exports.ExpandingMenu = ExpandingMenu;